module.exports = __webpack_public_path__ + "img/31c0688.jpg";